export default __webpack_public_path__ + "static/media/icon-content.svg";